var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.isManager
    ? _c("div", { staticClass: "container-check-in" }, [
        _c("div", { staticClass: "select-type" }, [
          _c("span", [_vm._v("选择类型")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.type,
                    expression: "type",
                  },
                ],
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.type = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { selected: "", value: "2" } }, [
                  _vm._v("二手房"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "3" } }, [_vm._v("租房")]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "select-type" }, [
          _c("span", [_vm._v("打卡方式")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.dk_type,
                    expression: "dk_type",
                  },
                ],
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.dk_type = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { selected: "", value: "phone" } }, [
                  _vm._v("手机号"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "bianhao" } }, [
                  _vm._v("客源编号"),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-phone" }, [
          _vm.dk_type == "phone"
            ? _c("input", {
                attrs: { type: "text", placeholder: "请输入客户手机号" },
                domProps: { value: _vm.phone },
                on: {
                  input: function ($event) {
                    return _vm.handelChange(11, "phone", $event)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.dk_type == "bianhao"
            ? _c("input", {
                attrs: { type: "text", placeholder: "请输入客源编号" },
                domProps: { value: _vm.phone },
                on: {
                  input: function ($event) {
                    return _vm.handelChange(11, "phone", $event)
                  },
                },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            class: ["btn-commit", { disable: _vm.isFromDisable }],
            on: { click: _vm.commit },
          },
          [_vm._v("提交")]
        ),
      ])
    : _c("div", { staticClass: "container-check-in no" }, [_vm._v("暂无权限")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }